import script from "./Show.vue?vue&type=script&setup=true&lang=js"
export * from "./Show.vue?vue&type=script&setup=true&lang=js"

export default script